import React from 'react'


const SliderOne = () => {
  return (
    <div className='slideronemore'>
        <img width="100%" src="https://static.thcdn.com/images/medium/webp/widgets/208-us/50/1031-STDCRE-43056-DS-WC-November-Batching-Shot-19-HP_LPSQ_BANNER_676x556-050250.jpg" alt="" />
    </div>
  )
}

export default SliderOne